import { NgModule } from "@angular/core";
import { NumericTextboxFormComponent } from './numeric-textbox-form/numeric-textbox-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { DynamicNumericTextboxComponent } from './dynamic-numeric-textbox.component';
import { NumericTextboxDesignComponent } from './numeric-textbox-design/numeric-textbox-design.component';
import {MatInputModule} from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { NumericTextboxResultComponent } from './numeric-textbox-result/numeric-textbox-result.component';
import { InputMaskModule } from '@ngneat/input-mask';
import { KendoModule } from '../kendo.module';
import { AbwConditionalFormatingModule } from '../@core/abw-conditional-text-formating.module';

@NgModule({
    declarations: [
        DynamicNumericTextboxComponent, NumericTextboxFormComponent, NumericTextboxDesignComponent, NumericTextboxResultComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        KendoModule,
        MatInputModule,
        InputMaskModule,
        AbwConditionalFormatingModule
    ],
    entryComponents: [
        DynamicNumericTextboxComponent
    ]
})
export class NumericTextboxModule {}